import { v4 as uuidv4 } from 'uuid';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { post } from '../Utils/fetch';
import useClientState from './use-client-state';

const usePayment = () => {
  const { state } = useClientState();
  const stripe = useStripe();
  const elements = useElements();

  const handleCardAction = async (endpoint, options, client_secret) => {
    const { paymentIntent, error } = await stripe.handleCardAction(client_secret);
    if (error) throw error;

    const optionsWithIntentId = {
      ...options,
      uuid: uuidv4(),
      intentId: paymentIntent.id,
    };

    try {
      const request = await post(endpoint, optionsWithIntentId);
      return request;
    } catch (error) {
      throw error;
    }
  };

  const handlePayment = async (endpoint, options, method) => {
    let paymentMethodId;

    if (method) paymentMethodId = method.id;

    if (!method) {
      const cardElement = elements.getElement(CardElement);

      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });
      if (error) throw error;

      paymentMethodId = paymentMethod.id;
    }

    const optionsWithPaymentMethodId = {
      ...options,
      uuid: state.payment.uuid,
      paymentMethodId: paymentMethodId,
    };

    try {
      const request = await post(endpoint, optionsWithPaymentMethodId);
      if (request.requires_action) {
        return handleCardAction(endpoint, options, request.client_secret);
      }

      return request;
    } catch (error) {
      throw error;
    }
  };

  return { stripe, handlePayment };
};

export default usePayment;
